/**
 * Map a tool-spec `change_kind` enum value (snake_case) to the short
 * uppercase badge label rendered in the chat sidebar's cypher-write
 * card. Unknown kinds fall through verbatim so a future enum addition
 * still renders something readable without forcing a UI change.
 */
const CHANGE_KIND_LABEL: Record<string, string> = {
  create_nodes: 'create',
  create_relationships: 'link',
  update_properties: 'update',
  node_evidence: 'evidence',
  delete: 'delete'
}

export function changeKindLabel(kind: string): string {
  return CHANGE_KIND_LABEL[kind] ?? kind
}
